import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/wdh_logo.png'


import { ref, watch } from 'vue';
    import AuthenticationButton from "@/ComponentsChild/AuthenticationButton.vue";

    
export default /*#__PURE__*/_defineComponent({
  __name: 'MainNavigation',
  setup(__props) {

    const drawer = ref(false);
    const group = ref(null);
    //let registered = ref(true)

    const items = ref([
        { icon: 'mdi-home', text: 'Home', route: '/' },
        { icon: 'mdi-account-circle', text: 'Register', route: 'register' },
        { icon: 'mdi-file-document', text: 'Application', route: 'application' },

    ]);

    const registeredItems = ref([
        { icon: 'mdi-file-document-check', text: 'Application Status', route: 'application-status' }
    ])

    watch(group, () => {
        drawer.value = false;
    });


return (_ctx: any,_cache: any) => {
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_app_bar, {
      app: "",
      dark: "",
      clipped: "true",
      color: "primary"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_toolbar_title, null, {
          default: _withCtx(() => [
            _createTextVNode(" Wyoming Department of Health - Medicaid Waiver Participant Portal ")
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_navigation_drawer, {
      location: "left",
      color: "secondary",
      permanent: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_list_item, { class: "d-flex justify-center align-center" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_img, {
              src: _imports_0,
              alt: "Wyoming Department of Health",
              style: {"width":"100px","max-height":"200px"}
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_list, {
          lines: false,
          density: "compact",
          nav: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_list_item, {
              color: "primary",
              class: "text-left"
            }, {
              prepend: _withCtx(() => [
                _createVNode(_component_v_icon, { icon: "mdi-login" })
              ]),
              default: _withCtx(() => [
                _createVNode(_component_v_list_item_title, { class: "text-left" }, {
                  default: _withCtx(() => [
                    _createVNode(AuthenticationButton)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item, i) => {
              return (_openBlock(), _createBlock(_component_v_list_item, {
                key: i,
                value: item,
                to: item.route,
                "prepend-icon": item.icon,
                color: "primary",
                class: "text-left"
              }, {
                prepend: _withCtx(() => [
                  _createVNode(_component_v_icon, {
                    icon: item.icon
                  }, null, 8, ["icon"])
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item_title, {
                    textContent: _toDisplayString(item.text)
                  }, null, 8, ["textContent"])
                ]),
                _: 2
              }, 1032, ["value", "to", "prepend-icon"]))
            }), 128)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(registeredItems.value, (item, i) => {
              return (_openBlock(), _createBlock(_component_v_list_item, {
                key: i,
                value: item,
                to: item.route,
                "prepend-icon": item.icon,
                color: "primary",
                class: "text-left"
              }, {
                prepend: _withCtx(() => [
                  _createVNode(_component_v_icon, {
                    icon: item.icon
                  }, null, 8, ["icon"])
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item_title, {
                    textContent: _toDisplayString(item.text)
                  }, null, 8, ["textContent"])
                ]),
                _: 2
              }, 1032, ["value", "to", "prepend-icon"]))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})